const LEGAL_PLACEHOLDER_MARKERS = [
  "[Nombre completo o razón social]",
  "[Identificación fiscal]",
  "[Dirección registral completa]",
  "[Correo de contacto]",
  "[Número de contacto]",
  "academia indicada en los datos de contacto y fiscales",
];

/**
 * Draft legal templates used square-bracket prompts. Those must not appear
 * on the public terms/privacy pages.
 * @param {string | null | undefined} html
 * @returns {boolean}
 */
export function isLegalPlaceholderContent(html) {
  if (typeof html !== "string") {
    return true;
  }
  const trimmed = html.trim();
  if (!trimmed) {
    return true;
  }
  return LEGAL_PLACEHOLDER_MARKERS.some((marker) => trimmed.includes(marker));
}
